import React, { useEffect, useState, useCallback, ReactElement } from 'react'
import { API_URL } from 'constants/config'
import { Container, Alert, Spinner } from 'react-bootstrap'
import { connect, useDispatch, useSelector } from 'react-redux'
import { settlement } from 'actions/settlementActions'
import { consultantSettlement } from 'actions/consultantSettlementActions'
import { fetchIndividualEstimate } from 'actions/individualEstimateActions'
import { fetchIndividualEstimate as fetchIndividualEstimateConsultant } from 'actions/consultantIndividualEstimateActions'
import BannerMainImageSection from 'components/bannerMainImageSection'
import { theme } from 'utils/theme'
import * as E from 'components/pages/home/homeElements'
import * as C from './settlementsElements'
import { Row, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import {
  ISettlementInputProps,
  ISettlementRecipient,
  ISettlementRecipientDocument,
} from './ISettlementInputProps'
import Layout from '../../layout'
import { PrimaryButton, FlowGraph } from '@mmsg/louie'
import { httpVerbConstants } from '../../constants/actionTypes'
import { MdCheckCircle, MdError } from 'react-icons/md'
import { formatDateToString } from 'helpers'
import { Icon } from 'icons'
import ContactConsultant from 'components/contactConsultant'
import { MdErrorOutline } from 'react-icons/md'
import { useDropzone } from 'react-dropzone'
import { query } from 'services/utilities'

const Settlements = ({
  opportunityId,
  userFirstName,
  vehicleDescription,
  estimateId,
  recipients,
  accessToken,
  proposalEstimateId,
  isAuthenticated,
  isFetching,
  isValid,
}: ISettlementInputProps) => {
  var dispatch = useDispatch()
  let headers = { accessToken: accessToken }
  let isConsultant = useSelector(
    (state: any) => state.applicationRoles.isConsultant
  )

  useEffect(() => {
    if (isAuthenticated && opportunityId) getData()
  }, [isAuthenticated, opportunityId])

  const [uploadedFiles,setUploadedFiles] = useState<string[]>([])
  let uploadedFilesFileNames: string[] = useSelector((state: any) => state.settlement.insuranceDocUploadFiles && 
   state.settlement.insuranceDocUploadFiles.map((f:any)=> f.fileName))
   //Only set this state variable once, otherwise ... badness
  if(uploadedFilesFileNames && uploadedFilesFileNames.length > 0 && uploadedFiles && uploadedFiles.length === 0) 
   setUploadedFiles(uploadedFilesFileNames)

  const [submitDocsErrorMsg, setSubmitDocsErrorMsg ] = useState('')
  const [isUploading,setIsUploading] = useState(false)


  const getData = () => {
    isConsultant
      ? dispatch(consultantSettlement(opportunityId, headers))
      : dispatch(settlement(opportunityId))

    if (!proposalEstimateId) return
    if (proposalEstimateId === '00000000-0000-0000-0000-000000000000') return
    if (proposalEstimateId === estimateId) return
    if (isConsultant) {
      dispatch(
        fetchIndividualEstimateConsultant(
          opportunityId,
          proposalEstimateId,
          headers,
          httpVerbConstants.HTTP_GET
        )
      )
    } else {
      dispatch(
        fetchIndividualEstimate(
          opportunityId,
          proposalEstimateId,
          true,
          false // Make sure this call does not update the analytics data
        )
      )
    }
  }

  let displayUpload = false// ToDo: Enable this logic when the Insurance doc upload feature need to be enabled in DEP
  {/*useSelector(
    (state: any) =>
      state.individualEstimate &&
      state.individualEstimate.estimate &&
      state.individualEstimate.estimate.compInsurance !== 'Yes' &&
      isValid
  )*/}
  let uploadCompleted = useSelector(
    (state: any) =>
      state.settlement.insuranceDocUploadFiles &&
      state.settlement.insuranceDocUploadFiles.length >= 5
  )

  const ScrollToUploadSection = () => {
    var doc = document.getElementById('settlements.insurancedocs')
    if (doc)
      doc.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      })
  }

  const InfoMessageBox = {
    iconType: <C.InfoIcon theme={theme} size={`1.6em`} />,
    color: theme.colors.warning2,
    contrastColor: theme.colors.warningContrast,
    variantType: 'warning',
  }
  const WarningMessageBox = {
    iconType: <C.WarningIcon theme={theme} size={`1.6em`} />,
    color: theme.colors.warning2,
    contrastColor: theme.colors.warningContrast,
    variantType: 'warning',
  }
  const TickMessageBox = {
    iconType: <C.TickIcon theme={theme} size={`1.6em`} />,
    color: theme.colors.warning2,
    contrastColor: theme.colors.warningContrast,
    variantType: 'warning',
  }
  const SuccessMessageBox = {
    iconType: <C.SmileyIcon theme={theme} size={`1.6em`} />,
    color: theme.colors.alertGreen2,
    contrastColor: theme.colors.alertGreen,
    variantType: 'success',
  }
  const ErrorMessageBox = {
    iconType: <C.ErrorIcon theme={theme} size={`1.6em`} />,
    color: '#FCF4F2',
    contrastColor: theme.colors.danger,
    variantType: 'danger',
  }

  let bannerSubtitle: string = ""
  let bannerText: ReactElement = <></>
  let alertText: ReactElement = <></>
  let flowActive: number = 0
  let documentPrompt: string = ""
  let promptIcon: ReactElement = <></>
  let accordionTitleText: string = ""
  let messageBox = InfoMessageBox
  let headlineText = 'The wheels are in motion!'

  const updateTextFields = (minNotSigned: ISettlementRecipient | undefined) => {
    if (!minNotSigned) {
      displayUpload = false
      alertText = (
        <>
          <strong>Check your email.</strong>
          <br /> A complete version of the signed documents has been sent to
          your email. Please file this away for your records OR view the
          documents by clicking on "Go to Adobe Sign".
        </>
      )
      bannerSubtitle = `Congratulations ${userFirstName}!`
      bannerText = (
        <>
          You're all done! Now that the financier has finalised your lease,
          there are no additional steps to complete.
          <br /> Once you receive confirmation of settlement, don't forget to
          download the Oly app to your mobile which will help you keep track
          of things moving forward!
        </>
      )
      flowActive = 4
      messageBox = SuccessMessageBox
      documentPrompt = 'Completed'
      promptIcon = <MdCheckCircle style={{ color: theme.colors.alertGreen }} />
      accordionTitleText = ""
      headlineText = `Congratulations ${userFirstName}`
    } else
      switch (minNotSigned && minNotSigned.recipientType) {
        case 'Customer':
        case 'Customer Witness':
          bannerSubtitle = `It's time for the final step ${userFirstName}!`
          bannerText = (
            <>
              Your final step to get behind the wheel of your new{' '}
              {vehicleDescription} is to sign your lease documents. You'll be
              directed to Adobe Sign, where you can easily sign them
              electronically by following a few simple steps.
              <br />
              Once you are done, we will organise for your employer to sign the
              documents and have everything ready to finalise your lease.
            </>
          )

          if (
            minNotSigned &&
            minNotSigned.recipientType == 'Customer Witness'
          ) {
            alertText = (
              <>
                <strong>
                  Your witness has not signed the required documents.
                </strong>
                <br /> To ensure we can forward this to your employer in
                preparation for finalising your lease, please organise for these
                to be signed promptly.
              </>
            )
            messageBox = WarningMessageBox
            documentPrompt = ""
            accordionTitleText = 'Waiting for your witness to sign'
          } else {
            alertText = (
              <>
                <strong>Your signature is required.</strong>
                <br />
                Please click on the button "Go to Adobe Sign” to sign your
                documents electronically. Please note, you will be required to
                enter in a password. This is in lowercase, a combination of your
                date of birth and legal last name (e.g.140579smith).
                <strong>
                  {' '}
                  You may require someone to witness you signing these documents
                  either physically or over a video call, please refer to your
                  email with instructions on how to have them complete.
                </strong>
              </>
            )
            messageBox = InfoMessageBox
            documentPrompt = 'Waiting for your signature'
            accordionTitleText = `${
              docList ? docList.length : ''
            } settlement documents waiting for your signature`
          }
          promptIcon = <Icon iconType="BluePencil" size={1} />

          flowActive = 1
          break

        case 'Employer':
        case 'Employer Witness':
          bannerSubtitle = `It's time for the final step ${userFirstName}!`
          bannerText = (
            <>
              Thanks for signing the documents. You can sit back and relax and
              let us handle the rest of the paperwork for you.
              <br /> We will now organize for your employer to sign the
              documents.
            </>
          )
          alertText = (
            <>
              <strong>Your employer signature is required.</strong>
              <br />
              Now that you are done, we require your employer to sign off the
              required documents. We will be following their signature up to
              ensure we have everything required to finalise your lease.
            </>
          )
          flowActive = 2
          messageBox = InfoMessageBox
          documentPrompt = 'Waiting employer signature'
          promptIcon = <Icon iconType="WaitingDots" size={1} />
          accordionTitleText = `${
            docList && docList.length
          } settlement document${
            docList && docList.length > 1 ? 's' : ''
          } waiting your employer signature`

          break

        case 'Financier':
        case 'Financier Witness':
          displayUpload = false
          bannerSubtitle = `You are now ready for settlement!`
          bannerText = (
            <>
              We have received completed paperwork from your employer and have
              the required documents to finalise your lease. As we get closer to
              your lease start date, we will organise to send the financier your
              documents - once they sign, everything is all done!
            </>
          )
          alertText = (
            <>
              <strong>Waiting for settlement</strong>
              <br />
              We have everything required and will be working with the financier
              to finalise your lease. Sit back and relax!
            </>
          )
          messageBox = TickMessageBox
          documentPrompt = 'Waiting financier signature'
          flowActive = 3
          promptIcon = <Icon iconType="WaitingDots" size={1} />
          accordionTitleText = `${
            docList && docList.length
          } settlement document${
            docList && docList.length > 1 ? 's' : ''
          } waiting your financier signature`

          break
      }
    if (!isValid) {
      alertText = (
        <>
          <strong>Your document pack is currently on hold.</strong>
          <br />
          Please contact your consultant for help.
        </>
      )
      messageBox = ErrorMessageBox
      documentPrompt = 'On Hold'
      accordionTitleText =
        'Your document pack is on hold. Please contact your consultant for help.'

      promptIcon = (
        <MdError style={{ color: theme.colors.danger, marginRight: '6px' }} />
      )
    }
  }

  var customer = recipients.find(
    (r: ISettlementRecipient) => r.recipientType == 'Customer'
  )
  const signingUrl = customer ? customer.signingURL : null
  const customerSignedDate = customer
    ? formatDateToString(customer.signedOn, ' ', true)
    : null

  //Document list - find earliest not signed recipient
  let notSigned = recipients.filter(
    (r: ISettlementRecipient) => r.hasSigned == false
  )
  var minNotSigned = recipients.find(
    (r: ISettlementRecipient) =>
      r.order ==
      Math.min(...notSigned.map((o: ISettlementRecipient) => o.order))
  )
  let docList =
    isValid &&
    minNotSigned &&
    minNotSigned.documents.map((d: ISettlementRecipientDocument) => d.name)
  updateTextFields(minNotSigned)

  const gotoAdobe = () => {
    if (signingUrl != null) window.open(signingUrl)
  }

  const submitFiles = () => {
    setSubmitDocsErrorMsg('')
    setIsUploading(true)

    query(`${API_URL}/opportunity/${opportunityId}/UploadInsuranceDoc/oly`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({"UploadedFiles": currentFiles}),
    }).then(
      (data: any) => {
       //? green success message        
        setUploadedFiles(uploadedFiles => [...uploadedFiles, ...currentFiles.map((f:any)=> f.FileName)]);        
        setCurrentFiles([])
        setIsUploading(false)
        forceUpdate()
      },
      (error: any) => {
        setIsUploading(false)
        setSubmitDocsErrorMsg(error)
      }
    )
  }
  const [currentFiles, setCurrentFiles] = useState<any>([])
  const [isOver, setIsOver] = useState(false)

  const onDelete = (i: number) => {
    setIsOver(false)
    const temp = currentFiles
    temp.splice(i, 1)
    setCurrentFiles(temp)
    setIsOver(true)
    forceUpdate()
  }
  const forceUpdate: () => void = React.useState({})[1].bind(null, {})

  const onDrop = useCallback(
    //@ts-ignore
    (files) => {
      document.body.style.cursor = 'wait'
      currentFiles.length < 5 &&
      files.map((item: any) => {
        const reader = new FileReader()

        reader.onloadend = () => {
          const temp = currentFiles
          temp.push({
            FileName: item.path,
            base64Content: reader.result,
            FileType: item.type,
            IsSyncedToD365: false,
            UpdatedTime: new Date(),
          })
          setCurrentFiles(temp)
        }

        reader.onerror = () => {
          console.error('There was an issue reading the file.')
        }

        reader.readAsDataURL(item)
        return reader
      })

      setTimeout(()=> forceUpdate(), 50)
      document.body.style.cursor = 'default'
    
    },
    []
  )

  const { getRootProps, getInputProps, open } = useDropzone({
    // Disable click and keydown behavior
    noClick: true,
    noKeyboard: true,
    multiple: true,
    onDrop,
    maxSize: 5242880,
    maxFiles: 5,
    disabled: currentFiles.length >= 5,
    accept: {
      'image/jpeg': ['.jpeg', '.png', '.pdf'],
    },
  })

  if (isFetching)
    return (
      <Layout>
        <Container>
          <div className="mt-5 mb-5 d-flex justify-content-center">
            <img src="/images/loader.gif" alt="" />
          </div>
        </Container>
      </Layout>
    )
  else
    return (
      <Layout>
        <E.HomeContainer id="page" theme={theme}>
          <BannerMainImageSection
            id="settlements.bannermainsection"
          >
            <Row>
              <C.BannerTitleText id="settlement.title">
                {headlineText}
              </C.BannerTitleText>
            </Row>
            <C.BannerContentDiv>
              <C.BannerTextDiv>
                <C.BannerSubtitleText id="settlements.subtitle">
                  {bannerSubtitle}
                </C.BannerSubtitleText>
                <C.BannerText id="settlements.subtitle">
                  {bannerText}
                </C.BannerText>
              </C.BannerTextDiv>
              <div className="ml-3">
                <C.BannerButtonColDiv>
                  <C.BannerPrimaryInverted
                    extendInMob
                    className="mb-3"
                    id="settlements.signlink"
                    disabled={isConsultant || !isValid}
                    onClick={gotoAdobe}
                  >
                    Go to Adobe Sign
                  </C.BannerPrimaryInverted>

                  {displayUpload && (<C.BannerPrimaryInverted
                    className="mb-3"
                    extendInMob
                    id="settlements.uploaddocs"
                    onClick={ScrollToUploadSection}
                  >
                    Upload proof of insurance
                  </C.BannerPrimaryInverted>)}


                  <Link
                    to={`${
                      isConsultant ? '/consultant' : ''
                    }/proposal/${estimateId}/review`}
                    tabIndex={-1}
                  >
                    {
                      <C.BannerPrimaryButton
                        extendInMob
                        id="settlement.proposallink"
                      >
                        View my proposal again
                      </C.BannerPrimaryButton>
                    }
                  </Link>
                </C.BannerButtonColDiv>
              </div>
            </C.BannerContentDiv>
          </BannerMainImageSection>

          {displayUpload && !uploadCompleted && (
          <C.UploadInfoBanner id="settlements.infobanner">
            <b className="ml-5">
              Please upload your comprehensive motor vehicle policy/certificate
              of currency below to confirm that you have arranged your own
              Comprehensive Motor Vehicle Insurance Policy or Certificate of
              Currency.
            </b>
            <a onClick={ScrollToUploadSection} style={{ cursor: 'pointer' }}>
              {' '}
              Click here to upload.
            </a>
          </C.UploadInfoBanner>)}
          {!(displayUpload && !uploadCompleted) && (
            <div style={{ minHeight: '120px' }}></div>
          )}

          <Container>
            <C.AlertBannerDiv id="settlements.alertbanner">
              <Alert
                style={{
                  borderLeft: '7px solid ' + messageBox.contrastColor,
                  backgroundColor: messageBox.color,
                  color: messageBox.contrastColor,
                }}
                variant={messageBox.variantType}
                className="text-left"
              >
                {messageBox.iconType}
                <div className="text-small ml-3">
                  <div>{alertText}</div>
                </div>
              </Alert>
            </C.AlertBannerDiv>
          </Container>
          <C.ContentContainer>
            <C.SetTableHeadingBlock>
              <span className="ml-4">
                <C.SetTableDocHeading theme={theme}>
                  Settlement Documents
                </C.SetTableDocHeading>
                <C.CenterAlignDiv>
                  <Icon iconType="AdobeSign" />
                  <C.AdobeText>Powered by Adobe Sign</C.AdobeText>
                </C.CenterAlignDiv>
              </span>
              <span className="mt-3">
                <FlowGraph
                  brand="oly"
                  activeTill={flowActive}
                  items={['Customer', 'Employer', 'Financier']}
                ></FlowGraph>
              </span>
              <C.SetTableRightInfo>
                {documentPrompt && (
                  <C.CenterAlignDiv style={{ textAlign: 'right' }}>
                    {promptIcon}
                    <C.DocumentPrompt>{documentPrompt}</C.DocumentPrompt>
                  </C.CenterAlignDiv>
                )}
                {customerSignedDate && isValid && flowActive < 4 && (
                  <C.CustomerSignedDiv>
                    Customer signed date: {customerSignedDate}
                  </C.CustomerSignedDiv>
                )}
              </C.SetTableRightInfo>
            </C.SetTableHeadingBlock>
            <C.SetSubText></C.SetSubText>
            {flowActive < 4 && (
              <div>
                <div style={{ position: 'relative' }}>
                  <C.DocumentAccordionTitle>
                    <C.CenterAlignDiv>
                      <C.DocumentAccordionTitleIcon>
                        {promptIcon}
                      </C.DocumentAccordionTitleIcon>
                      <C.DocumentAccordionTitleText>
                        {accordionTitleText}
                      </C.DocumentAccordionTitleText>
                    </C.CenterAlignDiv>
                  </C.DocumentAccordionTitle>
                  <C.DocumentAccordion
                    title={null}
                    expandAccordion={false}
                    className="card-shadow"
                    defaultActive={isValid}
                  >
                    {docList &&
                      docList.map((item: string) => (
                        <C.DocumentBlock>{item}</C.DocumentBlock>
                      ))}
                  </C.DocumentAccordion>
                </div>
              </div>
            )}
            {flowActive == 4 && (
              <C.AllDoneDiv id="settlements.alldonediv">
                <Icon iconType="AllDone" className="mb-4" />
                All Done!
              </C.AllDoneDiv>
            )}
          </C.ContentContainer>
          <C.SignButtonContainer>
            <PrimaryButton
              disabled={isConsultant || !isValid}
              onClick={gotoAdobe}
              extendInMob
              className="mb-3"
            >
              Go to Adobe Sign
            </PrimaryButton>
          </C.SignButtonContainer>
        </E.HomeContainer>

  {displayUpload && (<div id="settlements.insurancedocs">
          {' '}
          {
            <>
              <hr />
              <div className='text-center'>
                <h3 className='mt-5'>
                  Upload your Comprehensive motor vehicle policy / Certificate
                  of currency
                </h3>
                <div>
                  if you have organised your own comprehensive insurance, kindly
                  upload a copy of your comprehensive motor vehicle policy/
                  certificate of currency, if you haven't already.
                </div>
              </div>
              <C.DroppingAreaBlock>
                <C.DropBoxContainer>
                  <C.DroppingArea {...getRootProps({ className: 'dropzone' })}>
                    <input {...getInputProps()} />
                    <Icon iconType="Upload" size={2.2} />
                    <div>Drag & Drop Comprehensive Motor Vehicle Insurance</div>
                    <div>Policy or Certificate of Currency </div>
                    <C.BlackButton
                      disabled={currentFiles.length >= 5 || isConsultant}
                      onClick={open}
                    >
                      Browse to upload
                    </C.BlackButton>
                  </C.DroppingArea>
                  <div>
                    Supported files include JPG, PNG and PDF. Maximum file size
                    is 5Mb per file.
                  </div>
                  <br />
                  <br />
                  <aside>
                    <h4>Files</h4>
                    <ul>
                      {currentFiles.map((file: any, i: any) => (
                        <div>
                          <Icon iconType="Attachment" size={2.2}></Icon>{' '}
                          <span key={file.FileName + i}>{file.FileName}</span>
                          <span onClick={() => onDelete(i)}>
                            {' '}
                            <Icon iconType="Trash" size={2.2} style={{cursor:'pointer'}}></Icon>{' '}
                          </span>
                          {i+1 < currentFiles.length &&<div style={{width:'30%'}}><hr /></div>}
                        </div>
                      ))}

                      {currentFiles && currentFiles !== 0 && uploadedFiles && uploadedFiles.length !== 0 && <div style={{width:'30%'}}><hr /></div>}
                      
                      {uploadedFiles && uploadedFiles.map((file:any, i: number) =>(
                      <div>
                        <Icon iconType="Attachment" size={2.2}></Icon>{' '}
                        <span>{file}</span>                       
                        <Icon iconType="BlackTick" size={1.0} />
                        {i+1 < uploadedFiles.length && <div style={{width:'30%'}}><hr /></div>}
                      </div>
                      ))}
                    </ul>
                  </aside>
                  <br />
                  <br />
                  {!isUploading && <PrimaryButton disabled={currentFiles.length === 0} onClick={submitFiles}>Submit files</PrimaryButton>}
                {isUploading && <PrimaryButton size="lg">
                  <>
                    <Spinner
                      as="span"
                      animation="grow"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="mb-1"
                    />
                    Submitting...
                  </>
                </PrimaryButton>}
                {submitDocsErrorMsg !== '' &&
                  <div className="mt-3">
                    <Alert variant="danger" className="text-left mt-3 w-100">
                      <MdErrorOutline
                        color="#AD240A"
                        size={`1.6em`}
                        style={{
                          minWidth: '20px',
                          position: 'absolute',
                          left: '3px',
                        }} 
                      />
                      <div className="text-small ml-3">
                      <div className="mb-1">
                        {submitDocsErrorMsg}{' '}
                        <ContactConsultant
                          textPrefix="Please"
                          textUnderline="contact your consultant"
                          textPostfix="to discuss."
                        />
                      </div>
                    </div>
                  </Alert>
                </div>}
                </C.DropBoxContainer>
                <div>
                  <C.NotificationArea>
                    <h3>Tips: Uploading your documents</h3>
                    <ul>
                      <li>Supported files include JPG, PNG and PDF</li>
                      <li>Maximum file size is 5Mb per file</li>
                      <li>Turn off the flash on your camera</li>
                      <li>Use a dark background</li>
                      <li>Take the photos on a flat surface</li>
                    </ul>
                  </C.NotificationArea>
                  <C.NotificationArea>
                    <h3>Please Note</h3>
                    <ul>
                      <li>
                        You can't delete the documents uploaded once you click the "Submit files" button
                      </li>
                    </ul>
                  </C.NotificationArea>
                </div>
              </C.DroppingAreaBlock>
            </>
          }
        </div>)}
      </Layout>
    )
}

function mapStateToProps(state: any) {
  const { isAuthenticated, opportunityId } = state.authentication
  const userFirstName = state.user.firstName
  let vehicle =
    state.individualEstimate &&
    state.individualEstimate.estimate &&
    state.individualEstimate.estimate.vehicle
  const vehicleDescription = vehicle
    ? `${vehicle.year} ${vehicle.make} ${vehicle.family}`
    : ''
  const estimateId =
    state.individualEstimate &&
    state.individualEstimate.estimate &&
    state.individualEstimate.estimate.id
  const proposalEstimateId =
    state.proposal && state.proposal.proposal && state.proposal.proposal.quoteId
      ? state.proposal.proposal.quoteId
      : null

  const accessToken = state.auth.accessToken
  const recipients = state.settlement && state.settlement.recipients
  const isFetching = state.settlement && state.settlement.isFetching
  const isValid = state.settlement && state.settlement.isValid

  return {
    opportunityId,
    userFirstName,
    vehicleDescription,
    estimateId,
    recipients,
    accessToken,
    proposalEstimateId,
    isAuthenticated,
    isFetching,
    isValid,
  }
}

export default connect(mapStateToProps)(Settlements)
